/*
 * @Author: your name
 * @Date: 2020-10-13 12:53:40
 * @LastEditTime: 2020-10-22 15:59:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\static\js\store.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        mutations:'',
        params:{}
    },
    mutations: {//同步修改属性
        routeParmas:function(state,data){
           // console.log(data)
           state.params=data
        }
      },
      getters:{ //计算
        saleProducts:function (state,data)   {
            // console.log(data)
        }
      } 
})

export default store


// WEBPACK FOOTER //
// ./static/js/store.js